import { Injectable } from '@angular/core';
import { Configuration } from '../../shared/models/configurations/configuration.interface';
import { DefaultConfiguration } from '../../shared/models/configurations/default-configuration';
import { ElimsConfiguration } from '../../shared/models/configurations/elims-configuration';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  config: Configuration;
  // app is the global namespace in Helium which holds all the configurations and urls
  app = (window as any).app;

  public static get isLimsHosted(): boolean{
    return typeof((window as any).app?.appVersion) !== "undefined";
  }

  constructor() {
    if (this.app?.appVersion) { // elims loads app version, eQMS standalone does not.
      this.config = new ElimsConfiguration(this.app);
    } else {
      this.config = new DefaultConfiguration();
    }
  }

  getReAuthFailedAttempts(): number {
    return this.config.getReAuthFailedAttempts();
  }

  isLimsHosted(): boolean {
    return this.config.isLimsHosted();
  }
}
